import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'pt',
    fullName: 'Portuguese',
    nativeName: 'Português',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Algo incrível está chegando",
    landing_subtitle: "ArgVoid é um estúdio de desenvolvimento de aplicativos e jogos. Fique ligado, novidades virão em breve!",
    select_language: "Selecione o idioma",
    search_placeholder: "Pesquisar idiomas...",
    terms_title: "Termos de Serviço",
    policy_title: "política de Privacidade",
    cookies_title: "Política de Cookies",
    terms_content: `
        <strong>1. Aceitação dos Termos</strong><br>
        Ao acessar o ArgVoid, estes Termos de Serviço são aceitos. Se estes termos não forem acordados, o serviço não deverá ser utilizado.<br><br>

        <strong>2. Uso da plataforma</strong><br>
        ArgVoid e seus aplicativos são fornecidos "como estão" para fins informativos e criativos. O serviço deve ser utilizado apenas para fins lícitos.<br><br>

        <strong>3. Conduta Proibida</strong><br>
        Explorar vulnerabilidades do site, enviar spam ou tentar acesso não autorizado à infraestrutura é estritamente proibido.<br><br>

        <strong>4. Isenção de responsabilidade</strong><br>
        A plataforma e os serviços podem ser modificados a qualquer momento sem aviso prévio. Nenhuma garantia é fornecida em relação ao tempo de atividade ou disponibilidade do serviço.
    `,
    policy_content: `
        <strong>1. Coleta de informações</strong><br>
        A plataforma não requer autenticação de usuário ou criação de conta neste momento. Nenhuma informação de identificação pessoal (como nomes ou endereços de e-mail) é coletada ativamente dos visitantes.<br><br>

        <strong>2. Dados de uso</strong><br>
        Análises básicas e anônimas podem ser coletadas para compreender o tráfego do site e melhorar os aplicativos. Esses dados não estão vinculados a identidades de usuários individuais.<br><br>

        <strong>3. Serviços de terceiros</strong><br>
        Fornecedores terceirizados podem ser utilizados para serviços de hospedagem e análise. As práticas de privacidade desses respectivos provedores regem os dados anônimos processados em suas infraestruturas.<br><br>

        <strong>4. Segurança de dados</strong><br>
        Medidas de segurança razoáveis são implementadas para proteger a plataforma. No entanto, nenhum método de transmissão pela Internet é totalmente seguro.<br><br>
    `,
    cookies_content: `
        <strong>1. O que são cookies e armazenamento local?</strong><br>
        Cookies e armazenamento local do navegador são pequenos arquivos de dados armazenados no dispositivo para lembrar preferências de configuração durante as visitas.<br><br>

        <strong>2. Finalidade de uso</strong><br>
        O Browser LocalStorage é usado estritamente para salvar configurações, como:<br>
        - Preferências de idioma<br>
        - Configuração da interface do usuário (por exemplo, configurações de layout ou tema)<br>
        - Cache temporário do aplicativo<br><br>

        <strong>3. Sem rastreamento</strong><br>
        Cookies e armazenamento local não são usados para fins publicitários ou de rastreamento de terceiros. Todos os dados armazenados são estritamente para a funcionalidade principal da plataforma.<br><br>

        <strong>4. Controle</strong><br>
        Os dados do navegador podem ser apagados a qualquer momento através das configurações do navegador, o que redefinirá quaisquer configurações locais.
    `,
    cookie_consent_text: "Utilizamos cookies básicos para garantir o correto funcionamento do site, como manter sua sessão ativa, salvar sua preferência de idioma e outras configurações personalizadas.",
    read_policy: "Leia a Política de Cookies",
    support_title: "Contate o suporte",
    support_subject_label: "Assunto",
    support_message_label: "Mensagem",
    support_submit_button: "Enviar mensagem",
    support_hint: "Nota: Isso abrirá seu aplicativo de e-mail padrão para enviar a mensagem.",
    support_success_msg: "Abrindo seu aplicativo de e-mail...",
    support_error_msg: "Falha ao enviar mensagem. Por favor, tente novamente mais tarde.",
    explorer_title: "Explorador",
    history_title: "História",
    animation_title: "Animação",
    config_title: "Configuração",
    tool_mouse: "Selecione (Ctrl+M)",
    tool_brush: "Pincel (Ctrl+B)",
    tool_brush_mode: "Alternar modo (sólido/claro)",
    tool_eraser: "Apagador (Ctrl+E)",
    tool_brush_size: "Ajustar o tamanho do pincel",
    tool_bucket: "Preencher (Ctrl+F)",
    tool_eyedropper: "Conta-gotas",
    tool_grid: "Grade (Ctrl+Shift+B)",
    tool_rotate: "Girar (Ctrl+Shift+R)",
    tool_flip_h: "Virar H (Ctrl+Shift+H)",
    tool_flip_v: "Virar V (Ctrl+Shift+V)",
    tool_transpose: "Transpor (Ctrl+Shift+T)",
    label_width: "Largura",
    label_height: "Altura",
    label_frames: "Número de quadros",
    label_animation: "Estilo de animação",
    label_background_color: "Cor de fundo",
    label_interval: "Intervalo",
    tool_anim_config: "Configuração de animação",
    label_new_width: "Nova largura",
    label_new_height: "Nova Altura",
    label_apply: "Aplicar",
    label_colors: "Cores",
    label_size: "Tamanho",
    label_tolerance: "Tolerância",
    val_horizontal: "Horizontal",
    val_vertical: "Vertical",
    val_sequence: "Sequência",
    val_bounce: "Quicar",
    val_random: "Aleatório",
    val_solid: "Sólido",
    val_clear: "Claro",
    action_add_sheet: "Nova planilha",
    action_import: "Importar",
    action_export: "Exportar",
    action_sort_projects: "Organizar",
    sort_date_old: "Mais antigo primeiro",
    sort_date_new: "Mais novo primeiro",
    sort_name_az: "Nome (A-Z)",
    sort_name_za: "Nome (Z-A)",
    action_new_sprite: "Novo Sprite",
    action_new_project: "Novo Projeto",
    modal_save_all_title: "Salvar todas as alterações",
    modal_save_all_desc: "Selecione os ativos para salvar:",
    modal_save_selected: "Salvar selecionado",
    action_saved: "Salvo",
    modal_create_sprite_title: "Criar novo sprite",
    modal_create_project_title: "Criar novo projeto",
    modal_add_sheet_title: "Adicionar nova planilha",
    modal_rename_sheet_title: "Renomear planilha",
    modal_rename_sprite_title: "Renomear Sprite",
    modal_delete_sprite_title: "Excluir Sprite",
    modal_delete_project_title: "Excluir projeto",
    modal_delete_sheet_title: "Excluir planilha",
    placeholder_sprite_name: "Nome",
    placeholder_project_name: "Nome",
    placeholder_sheet_name: "Nome",
    placeholder_new_name: "Novo nome",
    action_create: "Criar",
    action_add: "Adicionar",
    action_rename: "Renomear",
    action_duplicate: "Duplicado",
    action_delete: "Excluir",
    action_cancel: "Cancelar",
    confirm_delete_sprite: "Tem certeza de que deseja excluir este sprite?",
    confirm_delete_project: "Tem certeza de que deseja excluir este projeto? Todos os sprites serão removidos.",
    confirm_delete_sheet: "Tem certeza de que deseja excluir esta planilha?",
    err_select_sprite: "Selecione um ator primeiro.",
    err_select_project: "Selecione um projeto primeiro.",
    err_name_empty: "O nome não pode ficar vazio.",
    err_sprite_exists: "Já existe um sprite com esse nome.",
    err_project_exists: "Já existe um projeto com esse nome.",
    err_no_content: "Nenhum conteúdo para salvar.",
    err_no_changes: "Nenhuma alteração para salvar.",
    err_delete_last_sheet: "Não é possível excluir a última planilha.",
    err_extract_frames: "Não foi possível extrair nenhum quadro.",
    err_indexeddb: "Falha ao salvar localmente. Seu navegador pode não suportar IndexedDB.",
    msg_upload_success: "Carregamento bem-sucedido: {0}",
    msg_upload_failed: "Falha no upload: {0}",
    msg_save_success: "Salve com sucesso.",
    msg_saving: "Salvando...",
    msg_multi_save_result: "{0} ativos salvos. {1} falhas.",
    menu_title: "Menu",
    menu_save: "Salvar",
    menu_save_all: "Salvar tudo",
    menu_support: "Contate o suporte",
    label_local_storage: "Armazenamento local",
    label_sign_in: "Entrar",
    modal_export_title: "Exportar Sprite",
    label_filename: "Nome do arquivo",
    label_format: "Formatar",
    action_export_confirm: "Exportar",
};

export default translations;
